import { Component, OnInit, Input } from '@angular/core';
import { SiteJuridiction } from '../../../../../entities/site-juridiction';

@Component({
  selector: 'jhi-type-acte-attaque-avertissement',
  templateUrl: './type-acte-attaque-avertissement.component.html',
  styleUrls: ['./type-acte-attaque-avertissement.component.scss']
})
export class TypeActeAttaqueAvertissementComponent implements OnInit {

  @Input()
  typeActeAttaqueCode: string;

  @Input()
  siteJuridiction: SiteJuridiction;

  ngOnInit() {
  }

  isOnlyProcessedByCA44(): boolean {
    return ['DRIPERM', 'DRORPEPSM', 'DRCIPPTD'].some(code => code === this.typeActeAttaqueCode);
  }

  isOnlyProcessedByCA75(): boolean {
    return ['AMTRRS', 'ADGARSPE', 'DARCARLC', 'DMCRVEC', 'DACNCP', 'OUAJOP'].some(code => code === this.typeActeAttaqueCode);
  }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/juridiction/type-acte-attaque-section/type-acte-attaque-avertissement/type-acte-attaque-avertissement.component.ts